<template>
<div class="LeaderMgt">
    <keep-alive include="LeaderList">
        <router-view></router-view>
    </keep-alive>
</div>
</template>

<script>
import {initPage} from 'common/js/mixin'
export default {
    name: 'LeaderMgt',
    mixins: [initPage],
    data() {
        return {}
    },
    mounted() {
    },
    methods: {},
    filters: {},
    watch: {},
    computed: {},
    components: {}
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
.LeaderMgt {
}
</style>
